import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Buttons from 'theme/components/Buttons.style';
import * as Text from 'theme/components/Text.style';

export const Container = styled.button<{ $isFilled?: boolean }>`
  align-items: center;
  background-color: ${({ $isFilled }) =>
    $isFilled ? colours.neutral[100] : colours.neutral[200]};
  border: none;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  gap: 15px;
  overflow: hidden;
  padding: 15px;
  text-align: left;
  transition: background-color 0.15s ease;
  width: 100%;

  &:hover {
    background-color: ${({ $isFilled }) =>
      $isFilled ? colours.neutral[200] : colours.neutral[300]};
  }
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  height: 60px;
  overflow: visible;
  width: 50px;

  svg {
    display: block;
    height: auto;
    margin: -10px 0 0 -15px;
    width: 83px;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Title = styled(Text.P1Bold)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Subtitle = styled(Text.P1)`
  color: ${colours.neutral[600]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DownloadButton = styled(Buttons.GhostIcon)`
  flex-grow: 0;
  flex-shrink: 0;

  svg path {
    stroke: ${colours.neutral[900]};
  }

  &:hover,
  &:focus {
    background-color: ${colours.neutral[300]};
  }
`;
